import React, { useContext } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import ProtectedRoute from 'utils/ProtuctedRoute'
import UserContext from 'contexts/UserContext'
import Home from './home'
import Recharge from './recharge'
import Login from './login'
import Signup from './singup'
import Transfert from './transfert'
import Layout from 'components/Layout'
import Settings from './settings'
import Beneficiary from './beneficiary'
import SettingProfile from './settingProfile'
import Benefiaire from './transfertContainer/beneficiare'
import History from './history'
import Personalinformation from './personalinformation'
import MotDePassOublier from './motDePassOublier'
import Activation from './activation'
import EmailVerificationContainer from './emailVerificationContainer'
import SecureCard from './secureCard'
import Success from './success'
import Error from './error'
import PaimentFacture from './paimentFacture'
import Assurance from './assuranceContainer/assurance'
import RechargeCartePrepayee from './rechargePrepayee/rechargeCartePrepayee'
import TransfertWallet from './transfert-vers-wallet/page'
import PublicPayment from './publicPayment/index'
import AppMobile from './appMobile/success'
import VolumeSuccess from './Volume/success'
import DrapeauTunisie from 'assets/drapeauTunisie'
import Rewards from 'rewards/page'
// import Signup2 from './signup2'
const RootContainer = () => {
  const { user } = useContext(UserContext)
  const location = useLocation()

  return (
    <Layout
      show={
        location.pathname === '/publicpayment' ||
        location.pathname === '/login' ||
        // location.pathname === '/signup2' ||
        location.pathname === '/signup' ||
        location.pathname === '/forgotPassword' ||
        location.pathname.startsWith('/activation') ||
        location.pathname.startsWith('/reset-pass')||
        location.pathname === '/volume/success'||
        location.pathname === '/flagTunisie'

      }
      showSideBarRight={
        location.pathname === '/' ||
        location.pathname === '/personalinformation' ||
        location.pathname === '/beneficiary' ||
        location.pathname === '/history' ||
        location.pathname === '/assurance' ||
        location.pathname === '/paimentFacture'||
        location.pathname === '/Rewards'



      }
      DetailsUserContainer={
        location.pathname === '/settingProfile/1'||
        location.pathname === '/settingProfile/0'

      }
    >
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        {/* <Route path="/signup2" element={<Signup2 />} /> */}
        <Route path="/reset-pass/:token" element={<MotDePassOublier />} />
        <Route path="/activation/:token" element={<Activation />} />
        <Route path="/forgotPassword" element={<EmailVerificationContainer />} />
        <Route path="/publicpayment" element={<PublicPayment />} />
        <Route path="/flagTunisie" element={<DrapeauTunisie />} />

        {location.pathname !== '/activation/:token' && location.pathname !== '/reset-pass/:token' && (
          <Route element={<ProtectedRoute isAuthenticated={user?.success} />}>
            <Route path="/" element={<Home />} />
            <Route path="/transfert/:code" element={<Transfert />} />
            <Route path="/recharge" element={<Recharge />} />
            <Route path="/setting" element={<Settings />} />
            <Route path="/beneficiary" element={<Beneficiary />} />
            <Route path="/settingProfile/:code" element={<SettingProfile />} />
            <Route path="/history" element={<History />} />
            <Route path="/personalinformation" element={<Personalinformation />} />
            <Route path="/secureCard" element={<SecureCard />} />
            <Route path="/success" element={<Success />} />
            <Route path="appMobile/success" element={<AppMobile />} />
            <Route path="/error" element={<Error />} />
            <Route path="/paimentFacture" element={<PaimentFacture />} />
            <Route path="/assurance" element={<Assurance />} />
            <Route path="/rechargeCartePrepayee" element={<RechargeCartePrepayee />} />
            <Route path="/transfert-vers-wallet" element={<TransfertWallet />} />
            <Route path="/volume/success" element={<VolumeSuccess />} />
            <Route path="/Rewards" element={<Rewards />} />

          </Route>
        )}

        <Route path="*" element={<div>404 not found</div>} />
      </Routes>
    </Layout>
  )
}

export default RootContainer
